export default __webpack_public_path__ + "/dist/images/Gold.98ed235c9bfd5ffc0fcb268c021cd975.svg";